import React, { createContext, useEffect, useState } from 'react';

const ReportStatusContext = createContext();

export const ReportStatusProvider = ({ children }) => {
  const [searchKeyword, setSearchKeyword] = useState("");
  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sendList, setSendList] = useState([]);
  const [sendListLength, setSendListLength] = useState(0);
  const [currentTab, setCurrentTab] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  return (
    <ReportStatusContext.Provider
      value={{
        searchKeyword,
        setSearchKeyword,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        sendList,
        setSendList,
        sendListLength,
        setSendListLength,
        currentTab,
        setCurrentTab,
        isLoading,
        setIsLoading,
        isProcessing,
        setIsProcessing
      }}
    >
      {children}
    </ReportStatusContext.Provider>
  )
}

export default ReportStatusContext;